import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'WeIconFont',
  src: '/fonts/we-icons.ttf',
  fontWeight: 'normal',
});

export const styles = StyleSheet.create({
  itemsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 45,
    padding: 40,
    flexWrap: 'wrap',
  },
  eventStatisticsItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: 15,
  },
  icon: {
    fontFamily: 'WeIconFont',
    fontSize: 40,
    color: 'black',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  boldText: {
    fontSize: 14,
    fontFamily: 'Lato',
    fontWeight: 900,
  },
  regularText: {
    fontSize: 14,
    fontFamily: 'Lato',
    fontWeight: 300,
  },
});
